//import User from './data/User-123.json';

import authService from '@/services/authService';
import HttpFactory from '@/mixins/http.factory';
export default {
	name:'two-factor-auth-check',
	props:{
		email: {
			type: String,
			required: true,
			default: () => null
		},
		password: {
			type: String,
			required: true,
			default: () => null
		},
		response: {
			type: Object,
			required: true,
			default: () => null
		},
	},
	mixins:[HttpFactory],
	data () {
		return {
			otpToken:'',
			redirectUrl:'/',
			showSetupForm:false,
			codeData:null
		};
	},
	created(){
		this.init();
	},
	methods:{
		async init(){
			let _self=this;
			_self.showSetupForm=true;
			await _self.getCodeData();
		},
		async getCodeData(){
			const _self=this;
			_self.fn().clearMessage();
			try{
				let response=await _self.get('auth/getQRCode')
				if(response && response.data.Success===true){
					let responseData=response.data.Data;
					_self.codeData=responseData;
				}
				else{
					_self.userMsg.list=['An error occurred please try again later'];
				}
			}catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
		},
		skip2FA(){
			let _self=this;
			_self.storeCacheRedirect(_self.response);
		},
		storeCacheRedirect(response){
			let _self=this;
			if(response && response.data && response.data.Success){
				let access_token=response.data.AuthResponse.Token;
				authService.setAccessToken(access_token,true);
				authService.setAuthResponse(JSON.stringify(response.data),true);
				let redirectPath='/';
				if(response.data.User.userRoles && response.data.User.userRoles.length>0){
					redirectPath=response.data.User.userRoles[0].redirectPath?response.data.User.userRoles[0].redirectPath:redirectPath;
				}
				redirectPath='/admin/devops-customers';//temp
				_self.redirectUrl=redirectPath;
				_self.userMsg.type='info';
				_self.userMsg.list=['Authenticated redirecting....'];
				_self.$router.push(redirectPath);	
			}
		},
		async setupAccount(){
			let _self=this;
			_self.fn().clearMessage();
			if(!_self.codeData){
				_self.userMsg.list=['An error occurred please try again later.']
				_self.userMsg.show=true;
				return;
			}
			if(!_self.otpToken){
				_self.userMsg.list=['Please enter the OTP as shown on your device.']
				_self.userMsg.show=true;
				return;
			}
			let data={
				email:_self.email,
				password:_self.password,
				secret:_self.codeData.secret,
				otp:_self.otpToken
			};
			try{
				let response=await _self.post('auth/registerTFA',data);
				if(response && response.data && response.data.Success){
					_self.storeCacheRedirect(response);
				}
				else{
					_self.userMsg.list=['Invalid credentials'];
				}
			}catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
		}
	}
}